















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import {
  GETTER_CURRENT_USER_MEDIA_LIST,
  RERESH_CURRENT_USER_INS_MEDIA,
  REQUEST_CURRENT_INS_USER_MEDIA_MORE
} from "@/store/constants/ins_media_types";
import Popup from "@/components/Popup/Popup.vue";
import NavBar from "@/components/NavBar/NavBar.vue";
import Scroller from "@/components/Scroller/Scroller.vue";
import SelectUser from "@/components/SelectUser/SelectUser.vue";
import InsMedia from "./InsMedia/InsMedia.vue";
import PostGallerySwitch from "@/components/PostGallerySwitch/PostGallerySwitch.vue";
import { getStatusBarHeight } from "@/utils/js_bridge_info";
@Component({
  components: {
    Popup,
    NavBar,
    Scroller,
    SelectUser,
    InsMedia,
    PostGallerySwitch
  }
})
export default class InsMediaGallery extends Vue {
  @Action(RERESH_CURRENT_USER_INS_MEDIA)
  private refreshInsMedia: any;
  @Action(REQUEST_CURRENT_INS_USER_MEDIA_MORE)
  private requestMoreInsMedia: any;
  @Getter(GETTER_CURRENT_USER_MEDIA_LIST)
  private currentMediaList: any;
  @Prop()
  private value?: boolean;
  @Prop()
  private activeIndex?: number;
  @Prop()
  private showInsGallery?: boolean;
  private popShow = false;
  // private height = 0;
  @Watch("value", { immediate: true })
  private changePop(val: boolean, oldVal: boolean) {
    this.popShow = val;
  }
  @Watch("popShow", { immediate: true })
  private change(val: boolean, oldVal: boolean) {
    this.$emit("input", val);
  }

  get positionStyle() {
    return `top:${getStatusBarHeight() + 44}px`;
  }

  // 下拉刷新需要传done函数
  private async pullFn(done?: any) {
    try {
      await this.refreshInsMedia(true);
      done && done();
    } catch (error) {
      done && done();
    }
  }

  private async loadMoreFn(done: any) {
    try {
      const res = await this.requestMoreInsMedia();
      console.log("requestMoreInsMedia res:", res);
      const { more_available } = res;
      if (more_available === false) {
        // 没有更多
        done(res);
      } else {
        done();
      }
    } catch (error) {
      console.log("requestMoreInsMedia error:", error);
      // 判断是否已经到底了
      const { type } = error;
      if (type && type === "no_more_available") {
        // 没有更多
        done(true);
      } else {
        done();
      }
    }
  }

  private clickSelectUser() {
    this.$emit("clickSelectUser");
  }

  get height() {
    if (this.currentMediaList) {
      return 155 * Math.ceil(this.currentMediaList.ins_media_list.length / 3);
    } else {
      return 200;
    }
  }

  private clolsePopup() {
    this.$emit("input", false);
  }
}
